import { _DEBUG } from './constants';

export default () => {
  const $form = $('.js-prevalidate-form');

  if (!$form.length) {
    return false;
  }

  const $inputs = $(':input', $form).not(
    ':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]',
  );
  $inputs.each(function () {
    $(this).addClass('_prevalidate');
  });

  $('._prevalidate').focusout(function () {
    const $input = $(this);
    const fieldName = $input.attr('name');

    const actionUrl = '/rpc.php?action=formvalidate';
    const formData = {
      required: $input.attr('required') === 'required' ? 1 : 0,
      validate: $input.attr('name'),
      [$input.attr('name')]: $input.val(),
    };

    // try to use all data to validate a field in context
    let formDataTest = {
      required: $input.attr('required') === 'required' ? 1 : 0,
      validate: $input.attr('name'),
      [$input.attr('name')]: $input.val(),
      //depends: $input.dataset.dependson
      depends: $input.attr('data-dependson') === undefined ? null : $input.attr('data-dependson'),
    };

    const $errorDisplay = $input.closest('form').find(`._displaywarning_${fieldName}`);

    // let test = $(':input', $input.closest('form')).not(':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]');
    let test = $(':input', $input.closest('form')).not(':input[type=button], :input[type=submit], :input[type=reset]');
    test.each(function () {
      let $fieldname = $(this).attr('name');
      let $fieldvalue = $(this).val();
      formDataTest[$fieldname] = $fieldvalue;
    });

    if (_DEBUG) console.log('***************************');
    if (_DEBUG) console.log(formDataTest);

    $.ajax({
      type: 'POST',
      url: actionUrl,
      data: formDataTest,
      success: (data) => {
        if (data.valid === true) {
          $input.addClass('is-valid');

          if ($input.hasClass('is-invalid')) {
            $input.removeClass('is-invalid');

            if ($errorDisplay.length) {
              $errorDisplay.empty();
            } else {
              $input.next('.feedback-error').remove();
            }
          }
        } else if (data.valid === false) {
          $input.addClass('is-invalid');

          if ($input.hasClass('is-valid')) {
            $input.removeClass('is-valid');
          }

          if ($errorDisplay.length) {
            $errorDisplay.text(data.error_text);
          } else if ($input.next('.feedback-error').length) {
            $input.next('.feedback-error').text(data.error_text);
          } else {
            $input.after(`<p class="feedback-error">${data.error_text}</p>`);
          }
        }
      },
    });
  });
};
